import { OrganisationUsage, OverageUsage, ResourceActionType, Usage, UserInstancesUsage, UserUsage } from '../usage-api';

export interface UsageModel extends OrganisationUsage {
  loading: boolean;
  isDownloadingOrgReport: boolean;
  downloadingUserReportList: string[] | undefined;
  level: ResourceActionType | undefined;
  userInstancesUsage: UserInstancesUsage | undefined;
}

export function initialUsageModel(): UsageModel {
  return {
    loading: true,
    isAdmin: false,
    isDownloadingOrgReport: false,
    downloadingUserReportList: undefined,
    units: undefined,
    limits: undefined,
    level: undefined,
    userUsage: undefined,
    userInstancesUsage: undefined,
  };
}

function getUsageSum(usages: Usage[]): Usage {
  return usages.reduce(
    (acc, currVal) => ({
      compute: acc.compute + currVal.compute,
      egress: acc.egress + currVal.egress,
      storage: acc.storage + currVal.storage,
    }),
    { compute: 0, egress: 0, storage: 0 }
  );
}

export function getTotalUsage(usage: UserUsage[]): Usage {
  return getUsageSum(usage);
}

export function getTotalOverageCosts(usage: UserUsage[]): Usage | undefined {
  const overageCosts = usage.map((u) => u.overageCosts).filter(Boolean) as OverageUsage[];
  return !overageCosts.length ? undefined : getUsageSum(overageCosts);
}

export function getTotalUsageCosts(usage: UserUsage[]): Usage | undefined {
  const usageCosts = usage.map((u) => u.usageCosts).filter(Boolean) as Usage[];
  return !usageCosts.length ? undefined : getUsageSum(usageCosts);
}
